import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import checkSubscription from "../../helpers/checkSubscription";
import currentPackageSelector from "../../selectors/packageInfo";

const SubscriptionHandler = ({ children }) => {
    const history = useHistory();
    const packageInfo = useSelector(currentPackageSelector) || {};
    const { expiryDate } = packageInfo;

    React.useEffect(() => {
        if (expiryDate !== undefined) {
            if (!checkSubscription(expiryDate)) {
                history.push('/not-subscribed');
            }
        }
    },[expiryDate])

    return <>{children}</>

}

export default SubscriptionHandler;
